import { useEffect, useState } from "react";
import { apiFetch } from "../api/api";
import { Link } from "react-router-dom";

export default function StaffList() {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    try {
      setLoading(true);
      const res = await apiFetch("/admin/users/staff");
      setRows(res.data);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="space-y-6">
      {/* ================= HEADER CARD ================= */}
      <div className="bg-white rounded-2xl shadow p-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <h1 className="text-2xl font-bold text-purple-700">
              Manajemen Staff
            </h1>
            <p className="text-sm text-gray-500">
              Daftar akun staff dan admin sistem
            </p>
          </div>

          <Link
            to="/staff/create"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-purple-600 to-indigo-600 text-white px-5 py-2.5 rounded-xl shadow hover:scale-[1.02] transition"
          >
            <PlusIcon />
            Tambah Staff
          </Link>
        </div>
      </div>

      {/* ================= TABLE CARD ================= */}
      <div className="bg-white rounded-2xl shadow overflow-hidden">
        <table className="w-full">
          <thead className="bg-gradient-to-r from-purple-500 to-purple-600 text-white">
            <tr>
              <th className="px-5 py-3 text-left">Nama</th>
              <th className="px-5 py-3 text-left">Email</th>
              <th className="px-5 py-3 text-center">Role</th>
              <th className="px-5 py-3 text-center">Dibuat</th>
            </tr>
          </thead>

          <tbody>
            {loading && (
              <tr>
                <td colSpan={4} className="py-10 text-center text-gray-500">
                  Memuat data staff...
                </td>
              </tr>
            )}

            {!loading &&
              rows.map((r, i) => (
                <tr
                  key={r.id}
                  className={`border-b hover:bg-purple-50 transition ${
                    i % 2 === 0 ? "bg-white" : "bg-gray-50"
                  }`}
                >
                  <td className="px-5 py-3 font-medium text-gray-700">
                    {r.nama}
                  </td>

                  <td className="px-5 py-3 text-gray-600">
                    {r.email}
                  </td>

                  <td className="px-5 py-3 text-center">
                    <RoleBadge role={r.role} />
                  </td>

                  <td className="px-5 py-3 text-center text-gray-500 text-sm">
                    {formatDate(r.created_at)}
                  </td>
                </tr>
              ))}

            {!loading && rows.length === 0 && (
              <tr>
                <td
                  colSpan={4}
                  className="py-12 text-center text-gray-500"
                >
                  Belum ada data staff
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* =========================
   COMPONENTS
========================= */

function RoleBadge({ role }: { role: string }) {
  const map: Record<string, string> = {
    admin: "bg-red-100 text-red-700",
    staff: "bg-blue-100 text-blue-700"
  };

  return (
    <span
      className={`px-3 py-1 rounded-full text-sm font-semibold ${
        map[role] ?? "bg-gray-100 text-gray-700"
      }`}
    >
      {role}
    </span>
  );
}

function formatDate(date: string) {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("id-ID", {
    day: "2-digit",
    month: "short",
    year: "numeric"
  });
}

/* =========================
   ICON
========================= */

function PlusIcon() {
  return (
    <svg
      className="w-5 h-5"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 4.5v15m7.5-7.5h-15"
      />
    </svg>
  );
}
